import {Bar} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    datalabels: {
      color: '#FFF',
      font: {
        size: 14,
      },
    },
  },
};

export default function CustomBar(value: {cellVolts?: number[]; temp?: number[]}) {
  let data: any = {};
  let highest = 0;
  let lowest = 0;
  if (value.cellVolts) {
    lowest = Math.min(...value.cellVolts);
    highest = Math.max(...value.cellVolts);
    let firstHighest = true;
    let firstLowest = true;
    const colors = value.cellVolts.map((x) => {
      if (x === lowest && firstLowest) {
        firstLowest = false;
        return '#32cd32';
      } else if (x === highest && firstHighest) {
        firstHighest = false;
        return '#ff0000';
      } else return '#0d74e8';
    });
    data = {
      labels: Array.from(value.cellVolts.map((_, i) => `C${i + 1}`)),
      datasets: [
        {
          label: 'Cell (mV)',
          data: value.cellVolts,
          backgroundColor: colors,
          borderRadius: 10,
        },
      ],
    };
  } else if (value.temp) {
    let firstHighest = true;
    let firstLowest = true;
    lowest = Math.min(...value.temp);
    highest = Math.max(...value.temp);

    const colors = value.temp.map((x) => {
      if (x === lowest && firstLowest) {
        firstLowest = false;
        return '#32cd32';
      } else if (x === highest && firstHighest) {
        firstHighest = false;
        return '#ff0000';
      } else return '#0d74e8';
    });
    const labels = Array.from(value.temp.map((_, i) => `T${i + 1}`));

    data = {
      labels,
      datasets: [
        {
          label: 'Temperature (\u2103)',
          data: value.temp,
          backgroundColor: colors,
          borderRadius: 10,
        },
      ],
    };
  }

  return (
    <div style={{width: '100%', height: '300px'}}>
      <Bar options={options} data={data} />
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-around',
          fontWeight: 'bold',
          padding: '5px',
          border: '1px solid black',
        }}
      >
        {value.temp ? (
          <div>Difference : {highest - lowest} &#8451;</div>
        ) : (
          <>
            <div>Difference : {highest - lowest} mV</div>
            <div>Maximum : {highest} mV</div>
            <div> Minimum : {lowest} mV</div>
          </>
        )}
      </div>
    </div>
  );
}
